import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const VerificationInput = (props) => {
  const { label, gif, name, ...rest } = props;

  return (
    <div className="question">
      <div className="question__verification_checkbox ">
        <div>
          <label htmlFor={name}>{label}</label>
        </div>
        <Field id={name} name={name} {...rest}>
          {({ field, form }) => (
            <label className={`radio radio--${field.value ? 'checked' : ''} verification`}>
              <input
                id={name}
                type="checkbox"
                checked={field.value}
                onChange={() => {
                  form.setFieldValue(name, !field.value);
                }}
              />
              <span className="checkmark-box verification" />
            </label>
          )}
        </Field>
      </div>
      {!!gif && (
        <div className="question__gif">
          <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
        </div>
      )}
    </div>
  );
};

VerificationInput.propTypes = {
  label: PropTypes.string.isRequired,
  gif: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default VerificationInput;
